export class AzureMarketplaceWebhookInput {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "id",
            "baseName": "id",
            "type": "string",
            "format": "uuid"
        },
        {
            "name": "activityId",
            "baseName": "activityId",
            "type": "string",
            "format": "uuid"
        },
        {
            "name": "publisherId",
            "baseName": "publisherId",
            "type": "string",
            "format": ""
        },
        {
            "name": "offerId",
            "baseName": "offerId",
            "type": "string",
            "format": ""
        },
        {
            "name": "planId",
            "baseName": "planId",
            "type": "string",
            "format": ""
        },
        {
            "name": "quantity",
            "baseName": "quantity",
            "type": "number",
            "format": ""
        },
        {
            "name": "subscriptionId",
            "baseName": "subscriptionId",
            "type": "string",
            "format": "uuid"
        },
        {
            "name": "timeStamp",
            "baseName": "timeStamp",
            "type": "Date",
            "format": "date-time"
        },
        {
            "name": "action",
            "baseName": "action",
            "type": "AzureMarketplaceWebhookInputActionEnum",
            "format": ""
        },
        {
            "name": "status",
            "baseName": "status",
            "type": "AzureMarketplaceWebhookInputStatusEnum",
            "format": ""
        },
        {
            "name": "operationRequestSource",
            "baseName": "operationRequestSource",
            "type": "AzureMarketplaceWebhookInputOperationRequestSourceEnum",
            "format": ""
        },
        {
            "name": "subscription",
            "baseName": "subscription",
            "type": "AzureMarketplaceWebhookInputSubscription",
            "format": ""
        },
        {
            "name": "purchaseToken",
            "baseName": "purchaseToken",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return AzureMarketplaceWebhookInput.attributeTypeMap;
    }
    constructor() {
    }
}
export var AzureMarketplaceWebhookInputActionEnum;
(function (AzureMarketplaceWebhookInputActionEnum) {
    AzureMarketplaceWebhookInputActionEnum["ChangePlan"] = "ChangePlan";
    AzureMarketplaceWebhookInputActionEnum["ChangeQuantity"] = "ChangeQuantity";
    AzureMarketplaceWebhookInputActionEnum["Renew"] = "Renew";
    AzureMarketplaceWebhookInputActionEnum["Suspend"] = "Suspend";
    AzureMarketplaceWebhookInputActionEnum["Unsubscribe"] = "Unsubscribe";
    AzureMarketplaceWebhookInputActionEnum["Reinstate"] = "Reinstate";
})(AzureMarketplaceWebhookInputActionEnum || (AzureMarketplaceWebhookInputActionEnum = {}));
export var AzureMarketplaceWebhookInputStatusEnum;
(function (AzureMarketplaceWebhookInputStatusEnum) {
    AzureMarketplaceWebhookInputStatusEnum["InProgress"] = "InProgress";
    AzureMarketplaceWebhookInputStatusEnum["Succeeded"] = "Succeeded";
    AzureMarketplaceWebhookInputStatusEnum["Failed"] = "Failed";
})(AzureMarketplaceWebhookInputStatusEnum || (AzureMarketplaceWebhookInputStatusEnum = {}));
export var AzureMarketplaceWebhookInputOperationRequestSourceEnum;
(function (AzureMarketplaceWebhookInputOperationRequestSourceEnum) {
    AzureMarketplaceWebhookInputOperationRequestSourceEnum["Azure"] = "Azure";
    AzureMarketplaceWebhookInputOperationRequestSourceEnum["Publisher"] = "Publisher";
})(AzureMarketplaceWebhookInputOperationRequestSourceEnum || (AzureMarketplaceWebhookInputOperationRequestSourceEnum = {}));
